import BasePage from  './basePage';
import Slide from '../components/slideIntro'
import VideoPlayer from "promokit-youtubeplayer";

export default class Intro1 extends BasePage{
  constructor(info){
    super(info);
    this.showMotion;
    this.slide = new Slide({
      ele:'#intro1-slide',
      isArrow:true,
      isPagination:true,
      autoPlay: false
    })

    /*this.player = new VideoPlayer({
      el: '#intro1-video',
      videoId: 'pfMwVK71z7E',
      loop: false,
      autoPlay: false
    });*/

    /*this.slide.addEventListener('startSlide', (index, currentIndex)=>{
      this.player.stop();
      this.player.pause()
      //this.player.seek(0.5);
    })*/
    this._motionSet();

  }
  _motionSet(){
    this.showMotion = new TimelineMax({paused: true, onComplete: this._showCompleteContent, onCompleteParams: [this]});
    this.showMotion
      .fromTo(this.ele.querySelector('.chr-1'), 3, {autoAlpha:0, x:400}, {autoAlpha:1, x:0, ease: 'chr'}, '+=0.5')
      .fromTo(this.ele.querySelector('.chr-1>span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Quart.easeInOut}, '-=2')

      .addLabel('obj', '-=2.5')
      .fromTo(this.ele.querySelector('.txt-1'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj')
      .fromTo(this.ele.querySelector('.txt-2'), 1, {autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj+=0.3')
      .fromTo(this.ele.querySelector('.txt-1>span'), 1, {autoAlpha:1}, {autoAlpha:0, ease: Quart.easeOut}, 'obj+=0.6')
      .fromTo(this.ele.querySelector('.slide-wrap'), 1, {autoAlpha:0}, {autoAlpha:1, ease: Quart.easeOut}, 'obj+=0.9')
      .fromTo(this.ele.querySelector('.slide-pagination'), 0.5, {autoAlpha:0, y:50}, {autoAlpha:1, y:0, ease: Quart.easeOut}, 'obj+=1.2')
      /*..fromTo(this.ele.querySelector('.slide-btn.prev'), 0.5, {x:50}, { x:0, ease: Quart.easeOut}, 'obj+=1.2')*/
      /*.fromTo(this.ele.querySelector('.slide-btn.next'), 0.5, { x:-50}, {x:0, ease: Quart.easeOut}, 'obj+=1.2')*/
      .fromTo(this.ele.querySelector('.icon-scroll'), 0.5, {autoAlpha:0, y:50}, {autoAlpha:0.8, y:0, ease: Quart.easeOut}, 'obj+=1.5')
      .fromTo(this.ele.querySelector('.btn-banner'), 0.5, {autoAlpha:0, x:50}, {autoAlpha:1, x:0, ease: Quart.easeOut}, 'obj+=1.5')


    //this.player.stop();
  };
  show(size, dx){
    super.show(size, dx)
    this.showMotion.seek(0)
    this.showMotion.play();
    this.slide.select = 0;
  }
  hide(size, dx, moveSec){
    super.hide(size, dx, moveSec)
    this.showMotion.pause();
    /*this.player.stop();
    this.player.pause()*/
  }
  _showCompleteContent(thisv){
  }
}



// WEBPACK FOOTER //
// ./src/js/page/intro1.js